<template>
  <div id="memberSearchPopup">
    <div class="common_popup_top_wrap">
      <div class="common_popup_search_wrap">
        <select v-model="searchParams.searchKeywordSelect">
          <option value="">없음</option>
          <option v-for="item in searchKeywordTypeList" :key="'keyword_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
        </select>
        <input type="text" v-model="searchParams.searchKeyword"/>
        <div class="btn_search" @click="search(1)">검색</div>
      </div>
    </div>
    <div class="common_list_wrap">
      <div class="common_list_middle">
        <div class="common_list_head">
          <div><span><input type="checkbox" v-model="checkAll" @click.stop="onClickCheckAll"/></span></div>
          <div><span>이름</span></div>
          <div><span>아이디</span></div>
          <div><span>본부</span></div>
          <div><span>소속</span></div>
          <div><span>담당업무</span></div>
          <div><span>전화번호</span></div>
          <div><span>상태</span></div>
        </div>
        <div class="common_list_body">
          <div class="common_list_no_data" v-if="list.length <= 0">
            <img src="../../assets/common/bg_list_no_data.png"/>
            <span>대상 모뎀이 없습니다.</span>
          </div>
          <div :key="'member_' + item.userPid" v-for="item in list">
            <div><span><input type="checkbox" v-model="item.check" @click.stop="onClickCheckItem(item)"/></span></div>
            <div><span>{{item.userName}}</span></div>
            <div><span>{{item.userId}}</span></div>
            <div>
              <span v-if="item.officeCode != null">
                <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (item.officeCode.length === 5 ? item.officeCode : item.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.affiliateCode != null">
                <template v-for="afc in afcList" v-if="afc.codeValue === item.affiliateCode">{{afc.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.chargeCode != null">
                <template v-for="rwk in rwkList" v-if="rwk.codeValue === item.chargeCode">{{rwk.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div><span>{{item.mobilePhone}}</span></div>
            <div>
              <template v-if="item.useState != null">
                <template v-for="ust in useStateList" v-if="ust.codeValue === item.useState">
                  <span :key="'ust_' + ust.codeValue" :class="item.useState === 0 ? 'fc_green' : item.useState === 2 || item.useState === 3 ? 'fc_red' : ''">{{ust.codeName}}</span>
                </template>
              </template>
              <span v-else>-</span>
            </div>
          </div>
        </div>
      </div>
      <div class="common_bottom_wrap padding_wrap">
        <div class="btn_bottom btn_close" @click="hidePopup">닫기</div>
        <div class="common_list_page_wrap center_page">
          <paginate
            v-model="pageParams.page"
            :pageCount="pageParams.totalPage"
            :clickHandler="search"
            :prevText="'<'"
            :nextText="'>'"
            :containerClass="'page_wrap'">
          </paginate>
        </div>
        <div class="btn_bottom btn_blue_t" @click="selectMember">선택</div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'
import user from '../../script/user'
import {defaultLoadingOptions} from '../../script/defaultConfig'

export default {
  props: ['popupParams'],
  data () {
    return {
      // Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      rwkList: [],
      useStateList: common.useStateList(),
      // Search
      searchKeywordTypeList: [
        { codePid: 0, codeValue: 'id', codeName: '아이디' },
        { codePid: 1, codeValue: 'name', codeName: '이름' }
      ],
      searchParams: {
        searchKeywordSelect: '',
        searchKeyword: ''
      },
      // List
      filter: {
        page: 1,
        size: parseInt(this.selectSize),
        userRole: 2
      },
      selectSize: '10',
      list: [],
      checkAll: false,
      selectedItemList: [],
      // Paging
      pageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 10,
        size: parseInt(this.selectSize)
      }
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('rwkList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.rwkList = JSON.parse(sessionStorage.getItem('rwkList'))
            this.search(1)
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    hidePopup (args) {
      this.$emit('hidePopup', args)
    },
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    onClickCheckAll () {
      this.selectedItemList = []
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].check = !this.checkAll
        if (!this.checkAll) {
          this.selectedItemList.push(this.list[i])
        }
      }
    },
    onClickCheckItem (selectedItem) {
      if (selectedItem.check) {
        this.selectedItemList = this.selectedItemList.filter(item => { return item.userPid !== selectedItem.userPid })
      } else {
        this.selectedItemList.push(selectedItem)
      }
      this.checkAll = this.selectedItemList.length === this.list.length
    },
    search (page) {
      this.filter = {
        page: page,
        size: parseInt(this.selectSize),
        userRole: 2,
        list: true
      }
      delete this.filter['userId']
      delete this.filter['userName']
      if (this.searchParams.searchKeywordSelect != null && this.searchParams.searchKeywordSelect !== '' &&
        this.searchParams.searchKeyword != null && this.searchParams.searchKeyword.length > 0) {
        if (this.searchParams.searchKeywordSelect === 'id') {
          this.filter.userId = this.searchParams.searchKeyword
        } else if (this.searchParams.searchKeywordSelect === 'name') {
          this.filter.userName = this.searchParams.searchKeyword
        }
      }
      this.updateList()
    },
    updateList () {
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      user.getUser(this.filter, response => {
        console.log('회원 검색 팝업', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          let list = data.list
          for (let i = 0; i < list.length; i++) {
            list[i].check = false
          }
          this.list = list
          this.pageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: this.filter.page,
            size: this.filter.size
          }
        } else {
          common.amsAlert('retry', '담당자 목록을 불러오지 못했습니다.')
          this.list = []
          this.pageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.filter.size
          }
        }
        this.checkAll = false
      })
    },
    selectMember () {
      if (this.selectedItemList.length <= 0) {
        common.amsAlert('general', '먼저 담당자를 선택하세요.')
        return
      }
      if (this.selectedItemList.length !== 1) {
        common.amsAlert('general', '담당자는 한 명만 선택하세요.')
        return
      }
      let member = {}
      for (let i = 0; i < this.selectedItemList.length; i++) {
        member = this.selectedItemList[i]
      }
      this.$emit('setSelectedItemList', {type: 'AS', data: member})
    }
  }
}
</script>

<style scoped>
#memberSearchPopup .common_popup_top_wrap {
  padding: 25px;
  background: #F8F8F8;
}

#memberSearchPopup .common_popup_top_wrap > .common_popup_search_wrap {
  display: flex;
  padding: 0 100px;
  gap: 20px;
}

#memberSearchPopup .common_popup_search_wrap > .btn_search {
  flex-shrink: 0;
  width: 77px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #E2E8ED;
  background: #3E7EFF;
  color: #FFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 56px;
  cursor: pointer;
}

#memberSearchPopup .common_popup_top_wrap > .common_popup_search_notice {
  margin: 16px auto 0;
  color: #36414F;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

#memberSearchPopup .common_list_wrap {
  width: 100%;
  margin-top: 25px;
}

#memberSearchPopup .common_list_wrap > .common_list_top {
  margin-left: 30px;
}

#memberSearchPopup .common_list_wrap > .common_list_top > div {
  color: #36414F;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
}

#memberSearchPopup .common_list_wrap > .common_list_middle {
  margin-top: 10px;
}

#memberSearchPopup .common_list_head > div {
  background: #F8F8F8;
}

#memberSearchPopup .common_list_middle > .common_list_body > div:nth-child(odd) {
  background: #FFFFFF;
}

#memberSearchPopup .common_list_middle > .common_list_body > div:nth-child(even) {
  background: #F8F8F8;
}

#memberSearchPopup .common_list_middle > .common_list_head > div,
#memberSearchPopup .common_list_middle > .common_list_body > div > div {
  width: 111px;
}

#memberSearchPopup .common_list_middle > .common_list_head > div:nth-child(1),
#memberSearchPopup .common_list_middle > .common_list_body > div > div:nth-child(1) {
  width: 13px;
}

#memberSearchPopup .common_list_middle > .common_list_body > div > div {
  color: #36414F;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

#memberSearchPopup .common_bottom_wrap > .btn_bottom {
  height: 46px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 46px;
}

#memberSearchPopup .common_bottom_wrap > .btn_close {
  width: 76px;
  margin: auto auto auto 0;
  color: #36414F;
}

#memberSearchPopup .common_bottom_wrap > .btn_blue_t {
  width: 118px;
  margin: auto 0 auto auto;
  color: #2D2D2D;
}

#memberSearchPopup .common_bottom_wrap > .common_list_page_wrap {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common/MemberSearchPopup.vue